import { gql } from "@apollo/client";

const ARCHIVE_TEST_MUTATION = gql`
  mutation archive_test($id: String!) {
    save_flow(id: $id, update: { archived: true }) {
      ok
    }
  }
`;

export { ARCHIVE_TEST_MUTATION };
